<template>
  <v-list-group v-if="loading || !isDisabled">
    <template v-slot:activator>
      <v-list-item-action>
        <v-icon>mdi-domain</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          Mandanten <span v-if="loading">(lädt)</span>
        </v-list-item-title>
      </v-list-item-content>
    </template>

    <v-list-item
      v-for="item in knownTenants"
      :key="item.id"
      @click="tenantSubmit(item)"
    >
      <v-list-item-action>
        <v-icon v-if="selectedTenant && (item.id === selectedTenant)">
          mdi-arrow-right
        </v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          {{ item.name }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list-group>
</template>

<script>
import { api, endpoints } from '@/api'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    isDisabled () {
      return this.knownTenants.length <= 1
    },
    ...mapGetters({
      selectedTenant: 'selectedTenant',
      knownTenants: 'knownTenants',
      profile: 'profile'
    })
  },
  watch: {
    async selectedTenant () {
      if (this.selectedTenant !== null) {
        const r = await api(endpoints.fetch_tenant(this.selectedTenant))
        try {
          if (r.ok) {
            const d = await r.json()
            this.updateSelectedTenantObj({tenant: d})
          } else {
            // TODO: proper error handling
            throw new Error('')
          }
        } catch (err) {
        } finally {
        }
      }
    },
    "profile.selected_tenant": {
      handler () {
        console.log(this.profile.selected_tenant)
      }
    }
  },
  created () {
    this.getTenants()
  },
  methods: {
    ...mapMutations([
      'updateKnownTenants',
      'updateSelectedTenant',
      'updateSelectedTenantObj'
    ]),
    ...mapActions ([
      'setProfile'
    ]),
    tenantSubmit (tenant) {
      this.setProfile({profile: {selected_tenant: tenant && tenant.id}})
      this.updateSelectedTenant({tenant: tenant && tenant.id})
    },
    async getTenants () {
      try {
        this.loading = true
        const r = await api(endpoints.fetch_tenants())
        if (r.ok) {
          const d = await r.json()
          this.updateKnownTenants({tenants: d})
          let tenantFound = false
          for (let tenant of d) {
            if (tenant.id === this.selectedTenant) {
              tenantFound = true
              break
            }
            if (tenant.id === this.profile.selected_tenant) {
              this.updateSelectedTenant({tenant: this.profile.selected_tenant})
              tenantFound = true
              break
            }
          }
          if (!tenantFound) {
           if (d.length > 0) {
              this.updateSelectedTenant({tenant: d[0].id})
            } else {
              this.updateSelectedTenant({tenant: null})
            }
          }
        } else {
          // TODO: Proper error handling
          throw new Error('')
        }
      } catch (err) {
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
